export interface CurriculumSubjectLink {
  tokenSlug: string
  pageSlug?: string
}

export const CURRICULUM_SUBJECT_LINKS: Record<string, CurriculumSubjectLink> = {
  aiForLeaders: {
    tokenSlug: 'ai-for-leaders',
    pageSlug: 'ai-for-leaders',
  },
  financeAndDataIntelligence: {
    tokenSlug: 'finance-and-data-intelligence',
    pageSlug: 'finance-data-intelligence',
  },
  modernMarketing: {
    tokenSlug: 'modern-marketing',
    pageSlug: 'modern-marketing',
  },
  aiFoundations: {
    tokenSlug: 'ai-foundations',
  },
  leadershipPrinciples: {
    tokenSlug: 'leadership-principles',
    pageSlug: 'leadership-principles',
  },
  productInnovation: {
    tokenSlug: 'product-innovation',
    pageSlug: 'product-innovation',
  },
  highOutputThinking: {
    tokenSlug: 'high-output-thinking',
    pageSlug: 'high-output-thinking',
  },
  careerPower: {
    tokenSlug: 'career-power',
    pageSlug: 'career-power',
  },
  powerAndInfluence: {
    tokenSlug: 'power-and-influence',
    pageSlug: 'power-influence',
  },
  strategyAndOperations: {
    tokenSlug: 'strategy-and-operations',
    pageSlug: 'strategy-operations',
  },
}
